<template>
  <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <div class="text-center">
      <div class="rounded-full bg-red-100 h-20 w-20 flex items-center justify-center mx-auto mb-6">
        <svg class="h-10 w-10 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>

      <h1 class="text-3xl font-bold text-gray-900 mb-4">
        Une erreur est survenue
      </h1>
      <p class="text-lg text-gray-600 mb-8">
        Le paiement de votre adhésion n'a pas pu être finalisé.
      </p>

      <div class="bg-white rounded-xl shadow-md p-6 mb-8">
        <h2 class="text-xl font-semibold text-gray-900 mb-4">Que faire ?</h2>
        <ul class="space-y-4 text-left">
          <li class="flex items-start">
            <svg class="h-6 w-6 text-gray-400 mr-3 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            <span>Vérifiez que votre carte bancaire est bien active</span>
          </li>
          <li class="flex items-start">
            <svg class="h-6 w-6 text-gray-400 mr-3 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            <span>Assurez-vous d'avoir suffisamment de fonds disponibles</span>
          </li>
          <li class="flex items-start">
            <svg class="h-6 w-6 text-gray-400 mr-3 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            <span>Contactez votre banque si le problème persiste</span>
          </li>
        </ul>
      </div>

      <div class="space-x-4">
        <router-link
          to="/public-subscribe"
          class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-zebu-orange hover:bg-zebu-orange/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-zebu-orange"
        >
          Réessayer
        </router-link>
        <router-link
          to="/dashboard"
          class="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-lg shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-zebu-orange"
        >
          Retour à l'accueil
        </router-link>
      </div>
    </div>
  </div>
</template> 